<div>
  <label class="block">
    <app-label
      [text]="label"
      [required]="required"
    ></app-label>
    <textarea
      class="text-black p-12 block w-full rounded-lg bg-white"
      placeholder="Type your message..."
      rows="8"
    ></textarea>
    <app-required-message [text]="requiredErrorMessage"></app-required-message>
  </label>
</div>
